
import React, { useState } from 'react';
import hicon from '../../images/icon/magic.svg'
import { Fade } from "react-awesome-reveal";
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';

const FaqSection = (props) => {

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <section className="faq pb-140">
            <div className="container">
                <div className="sec-title--two text-center mb-60">
                    <Fade direction='down' triggerOnce={'false'} duration={1000} delay={9}>
                        <div>
                            <div className="sub-title wow fadeInDown" data-wow-duration="600ms"><img
                                src={hicon} alt="" />FAQ’s</div>
                        </div>
                    </Fade>
                    <Fade direction='up' triggerOnce={'false'} duration={1200} delay={9}>
                        <div>
                            <h2 className="title wow fadeInDown" data-wow-delay="150ms" data-wow-duration="600ms">Have a
                                question look here</h2>
                        </div>
                    </Fade>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="xb-faq wow fadeInUp" data-wow-delay="200ms" data-wow-duration="600ms">
                            <Accordion open={open} toggle={toggle} className='accordion_box clearfix list-unstyled'>
                            <AccordionItem className='block'>
    <AccordionHeader targetId="1" className='acc-btn'>
        <span className="number">01</span> &nbsp;How long does it take to activate my account?
        <span className="arrow"></span>
    </AccordionHeader>
    <AccordionBody accordionId="1" className='acc_body'>
        <div className="content">
            <p>Your AllGuard.io account is activated instantly upon completing registration. You’ll receive an email with login details and a quick setup guide within minutes.</p>
            <p>To list events, sell tickets, or process payments, you’ll need to complete our selfie-verified KYC process, which typically takes 24-48 hours once submitted.</p>
        </div>
    </AccordionBody>
</AccordionItem>

<AccordionItem className='block'>
    <AccordionHeader targetId="2" className='acc-btn'>
        <span className="number">02</span> &nbsp;Can I cancel my subscription?
        <span className="arrow"></span>
    </AccordionHeader>
    <AccordionBody accordionId="2" className='acc_body'>
        <div className="content">
            <p>Absolutely! You can cancel your AllGuard.io subscription anytime via your dashboard. There’s no penalty—your access remains active until the current billing cycle ends, and no further charges will apply.</p>
        </div>
    </AccordionBody>
</AccordionItem>

<AccordionItem className='block'>
    <AccordionHeader targetId="3" className='acc-btn'>
        <span className="number">03</span> &nbsp;How does selfie-verification work for ticketing?
        <span className="arrow"></span>
    </AccordionHeader>
    <AccordionBody accordionId="3" className='acc_body'>
        <div className="content">
            <p>Our selfie-verification ensures secure ticketing by confirming the buyer’s identity. When purchasing a ticket, users upload a quick selfie, which we match against their payment details. At the event, staff verify attendees with the same process, reducing fraud and chargebacks.</p>
        </div>
    </AccordionBody>
</AccordionItem>

<AccordionItem className='block'>
    <AccordionHeader targetId="4" className='acc-btn'>
        <span className="number">04</span> &nbsp;What fees do you charge for events and memberships?
        <span className="arrow"></span>
    </AccordionHeader>
    <AccordionBody accordionId="4" className='acc_body'>
        <div className="content">
            <p>AllGuard.io keeps it affordable: event organizers pay a low monthly SaaS fee (starting at £25) plus a small per-ticket fee (e.g., 1% + £0.20), far below platforms like Ticketmaster. Memberships start at £10/month for basic access. No hidden costs—full pricing is in your dashboard.</p>
        </div>
    </AccordionBody>
</AccordionItem>

<AccordionItem className='block'>
    <AccordionHeader targetId="5" className='acc-btn'>
        <span className="number">05</span> &nbsp;Can I use AllGuard for both online and in-person events?
        <span className="arrow"></span>
    </AccordionHeader>
    <AccordionBody accordionId="5" className='acc_body'>
        <div className="content">
            <p>Yes! AllGuard.io is built for both. Sell tickets online with our Event Marketplace, and use our mobile-friendly check-in system at the door—complete with selfie-verification—to manage in-person attendees seamlessly.</p>
        </div>
    </AccordionBody>
</AccordionItem>

                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};
export default FaqSection;
